import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAutocompleteItemsComponent } from '@fi-shared/fi-autocomplete-items/fi-autocomplete-items.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatChipsModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatOptionModule,
        SelectSearchModule,
    ],
    declarations: [FiAutocompleteItemsComponent],
    exports: [FiAutocompleteItemsComponent],
})
export class FiAutocompleteItemsModule {}
